import { resolveLineItemQuantity } from "./lineItemDisplay";

/**
 * Stable key for estimate-subscription requests. Used to skip duplicate API calls
 * when React effects re-run with the same logical inputs (new object refs only).
 */
export function buildEstimateRequestSignature({
  billingConnectionId,
  planId,
  currency,
  country,
  couponCodes,
  subscriptionItems,
  forceTrialPeriodDays,
}) {
  if (!billingConnectionId || !planId || !currency) return null;

  const items = (subscriptionItems || [])
    .map((item) => ({
      id: item.itemPriceId,
      q: item.quantity ?? 1,
    }))
    .sort((a, b) => a.id.localeCompare(b.id));

  const coupons = [...(couponCodes || [])].map((c) => c.trim()).filter(Boolean).sort();

  return JSON.stringify({
    billingConnectionId,
    planId,
    currency,
    country: country || null,
    coupons,
    items,
    forceTrialPeriodDays: forceTrialPeriodDays ?? null,
  });
}

export function buildSubscriptionEstimateItems({
  planId,
  platformItem,
  platformItemDetails,
  selectedAddons,
}) {
  if (!planId || !platformItem) return [];

  const billingPlatformName = platformItem.billingPlatformName;

  return [
    {
      itemPriceId: planId,
      quantity: resolveLineItemQuantity(billingPlatformName, platformItem, 1),
    },
    ...(selectedAddons || []).map((addon) => {
      const catalog = platformItemDetails?.find(
        (p) => p.id === addon.itemPriceId || p.code === addon.itemPriceId
      );
      return {
        itemPriceId: addon.itemPriceId,
        quantity: resolveLineItemQuantity(
          billingPlatformName,
          catalog || addon,
          addon.quantity
        ),
      };
    }),
  ];
}

export function buildSubscriptionEstimatePayload({
  currency,
  subscriptionItems,
  country,
  couponCodes,
  forceTrialPeriodDays,
}) {
  const payload = {
    currency,
    subscriptionItems,
  };

  if (country) {
    payload.customerBillingInfo = {
      billingAddress: { country },
    };
  }

  if (couponCodes?.length) {
    payload.couponCodes = couponCodes;
  }

  if (forceTrialPeriodDays != null) {
    payload.forceTrialPeriodDays = forceTrialPeriodDays;
  }

  return payload;
}
